import * as React from 'react';

import {Axis} from './axis.story';
import {Basic} from './basic.story';
import {Color} from './color.story';
import {Domain} from './domain.story';

export const getChartExamples = (chartName) => ({
  axis: {
    rendered: <Axis chart={chartName} />,
    source: `<${chartName}
  data={[
    {
      date: 'January',
      sold: 10,
    },
    {
      date: 'February',
      sold: 41,
    },
    {
      date: 'March',
      sold: 22,
    },
    {
      date: 'April',
      sold: 38,
    },
  ]}
  x="date"
  y={{value: 'sold', label: 'Price', format: {currency: 'USD'}}}
/>`,
  },
  basic: {
    rendered: <Basic chart={chartName} />,
    source: `const sales = [
  {
    date: 'Jan',
    sold: 1
  },
  {
    date: 'Feb',
    sold: 4
  },
  {
    date: 'Mar',
    sold: 2
  },
  {
    date: 'Apr',
    sold: 3
  }
];

<${chartName} data={sales} x="date" y="sold" />`,
  },
  color: {
    rendered: <Color chart={chartName} />,
    source: `const sales = [
  {
    date: 'Jan',
    sold: 1,
    product: 'tables'
  },
  {
    date: 'Jan',
    sold: 2,
    product: 'chairs'
  },
  {
    date: 'Feb',
    sold: 4,
    product: 'tables'
  },
  {
    date: 'Feb',
    sold: 6,
    product: 'chairs'
  },
  {
    date: 'Mar',
    sold: 2,
    product: 'tables'
  },
  {
    date: 'Mar',
    sold: 4,
    product: 'chairs'
  },
  {
    date: 'Apr',
    sold: 7,
    product: 'tables',
  },
  {
    date: 'Apr',
    sold: 9,
    product: 'chairs',
  },
];

<${chartName} data={sales} x="date" y="sold" color="product" />`,
  },
  domain: {
    rendered: <Domain chart={chartName} />,
    source: `const sales = [
  {
    date: 'Jan',
    sold: 1,
  },
  {
    date: 'Feb',
    sold: 4,
  },
  {
    date: 'Mar',
    sold: 2,
  },
  {
    date: 'Apr',
    sold: 3,
  },
];

<${chartName}
  data={sales}
  x="date"
  y={{value: 'sold', label: 'Sold', domain: [0, 10]}}
/>`,
  },
});

export const BarChartExamples = getChartExamples('BarChart');
export const LineChartExamples = getChartExamples('LineChart');
